const printsGrid = (settings = {}) => {
  return {
    settings,
    loading: false,
    error: '',
    items: [],

    init() {
      this.fetchItems();
    },

    async fetchItems() {
      this.loading = true;
      this.error = '';

      try {
        const listType = 'print_collection_list';
        const listHandle = this.settings.print_collection_list_handle || '';
        const fieldKeys = this.settings.sale_mode ? ['sale_prints_grid', 'prints_on_sale'] : ['prints_grid', 'prints'];
        const orderedEntries = await this.fetchPrintCollectionList(listType, listHandle, fieldKeys);

        this.items = orderedEntries.map((entry) => this.mapItem(entry)).filter((item) => item.title);

        if (!this.settings.sale_mode) {
          this.appendSaleTeaser();
        }
      } catch (error) {
        console.error('[PrintsGrid] Failed to fetch items:', error);
        this.error = 'Unable to load items at the moment.';
      } finally {
        this.loading = false;
      }
    },

    mapItem(entry) {
      const title = this.getFieldValue(entry.fields, 'title') || '';
      const imageField = this.getField(entry.fields, 'circular_image');
      const collectionField = this.getField(entry.fields, 'collection_url');

      const image = imageField?.reference?.image
        ? {
            url: imageField.reference.image.url,
            alt: imageField.reference.image.altText || title,
            width: imageField.reference.image.width,
            height: imageField.reference.image.height
          }
        : null;

      const link = collectionField?.reference?.onlineStoreUrl || collectionField?.value || '';

      return {
        id: entry.id,
        title,
        image,
        link
      };
    },

    appendSaleTeaser() {
      const teaserTitle = this.settings.sale_teaser_title || '';
      const teaserLink = this.settings.sale_teaser_link || '';
      const teaserImageUrl = this.$el.dataset.saleTeaserImage || '';

      if (teaserTitle || teaserImageUrl) {
        this.items.push({
          id: '__sale-teaser__',
          title: teaserTitle,
          image: teaserImageUrl ? { url: teaserImageUrl, alt: teaserTitle, width: 320, height: 320 } : null,
          link: teaserLink
        });
      }
    },

    getField(fields, key) {
      return fields?.find((item) => item.key === key) || null;
    },

    getFieldValue(fields, key) {
      return this.getField(fields, key)?.value || '';
    },

    async fetchPrintCollectionList(listType, listHandle, fieldKeys) {
      const accessToken = window.themeSettings?.storefront_access_token;

      if (!accessToken) {
        throw new Error('Storefront access token not found in window.themeSettings');
      }

      if (!listHandle) {
        throw new Error('Print Collection List handle is required.');
      }

      const query = `
        query GetPrintCollectionList($type: String!, $handle: String!) {
          metaobject(handle: { type: $type, handle: $handle }) {
            id
            fields {
              key
              references(first: 250) {
                edges {
                  node {
                    ... on Metaobject {
                      id
                      fields {
                        key
                        value
                        reference {
                          ... on MediaImage {
                            image {
                              url
                              altText
                              width
                              height
                            }
                          }
                          ... on Collection {
                            onlineStoreUrl
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      const response = await fetch('/api/2023-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken
        },
        body: JSON.stringify({
          query,
          variables: { type: listType, handle: listHandle }
        })
      });

      if (!response.ok) {
        throw new Error(`GraphQL request failed: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      if (data.errors) {
        throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
      }

      const listEntry = data.data?.metaobject;
      if (!listEntry) return [];

      const gridField = listEntry.fields?.find((field) => fieldKeys.includes(field.key));
      if (!gridField?.references) return [];

      return gridField.references.edges.map((edge) => edge.node);
    }
  };
};

export default {
  name: 'printsGrid',
  component: printsGrid
};
